import { Component, Input } from '@angular/core';

@Component({
    selector: 'cut-phase-bar',
    template: require('./phase.html'),
    styles: [require('./phase.scss')]
})
export class PhaseComponent {

  @Input()
  public phaseLabel: string;

  @Input()
  public phaseLink: string;

  @Input()
  public isSolicitor: boolean;

}
